export enum OverwriteService {
  BATTLE_VALIDATOR = 'battle_validator',
  //TBD: ALL backend Central services
}

export class Pod {
  endpoint: string;
  repository: string;
  project: string;
  cmbranch?: string;
  config_branch?: string;
  branch: string;
  commit: string;
  status_reason: string;
  facebook_app_id: string;
  facebook_app_secret: string;
  facebook_app_namespace: string;
  is_production: string;
  statics_server: string;
  localizations_server: string;
  expiration: number;
  timestamp?: number;
  user?: string;
  sync_backend?: boolean;
  overwrite: any;

  constructor(public identifier: string = '', public status: string = '') {}
}

export const CUSTOM_PROJECTS_DATA = new Map([
  ['pg', { testenv: true, chart: 'pg-dynenv' }],
  ['gctpg', { testenv: true, chart: 'gctpg-dynenv' }],
  ['rck7d', { testenv: true, chart: 'rck7d-dynenv' }],
  ['spr', { testenv: true, chart: 'spr-dynenv' }],
  ['wl', { testenv: true, chart: 'wl-dynenv' }],
  ['bg', { testenv: true, chart: 'bg-dynenv' }],
  ['dc', { testenv: true, chart: 'dc-dynenv' }],
  ['mc', { testenv: true, chart: 'mc-dynenv' }],
  ['twd', { testenv: true, chart: 'twd-dynenv' }],
  ['fm2', { testenv: true, chart: 'fm2-dynenv' }],
  ['rt', { testenv: true, chart: 'rt-dynenv' }],
  ['ptm', { testenv: true, chart: 'ptm-dynenv' }],
  ['tmc', { testenv: true, chart: 'tmc-dynenv' }],
  ['sr', { testenv: true, chart: 'sr-dynenv' }],
  ['mip', { testenv: true, chart: 'mip-dynenv' }],
  ['twr', { testenv: true, chart: 'twr-dynenv' }],
  ['grd', { testenv: true, chart: 'grd-dynenv' }],
  ['bh', { testenv: true, chart: 'bh-dynenv' }],
  ['mb', { testenv: true, chart: 'mb-dynenv' }],
  ['sol', { testenv: true, chart: 'sol-dynenv' }],
  ['lpt11', { testenv: true, chart: 'lpt11-dynenv' }],
  ['glt7m', { testenv: true, chart: 'glt7m-dynenv' }],
  ['plp', { testenv: true, chart: 'plp-dynenv' }],
  ['rck7r', { testenv: true, chart: 'rck7r-dynenv' }],
  ['tyc88', { testenv: true, chart: 'tyc88-dynenv' }],
  ['grd8t', { testenv: true, chart: 'grd8t-dynenv' }],
]);

export const ProjectOverwriteServices = new Map<string, OverwriteService[]>([
  ['sem', [OverwriteService.BATTLE_VALIDATOR]],
]);
